<template>
  <aside
    class="h-screen min-h-screen bg-gradient-to-br from-[#1b1240] via-[#1b1240] to-[#2a0d4f] text-white
           transition-all duration-300 ease-in-out
           flex flex-col"
    :class="collapsed ? 'w-16' : 'w-56'"
  >
    <!-- Logo -->
    <div class="h-16 flex items-center justify-center border-b border-slate-700">
      <a href="/">
        <span class="text-lg font-bold" v-if="!collapsed">Links Digest</span>
        <span v-else class="text-xl">⚡</span>
      </a>
    </div>

    <!-- Links -->
    <nav class="flex-1 p-2 space-y-1">
      <RouterLink
        v-for="item in items"
        :key="item.label"
        :to="item.link"
        class="flex items-center gap-3 p-3 rounded-lg
               hover:bg-slate-800 transition"
        :title="collapsed ? item.label : ''"
      >
        <span
          class="w-6 h-6 flex items-center justify-center"
          v-html="item.icon"
        />
        <span
          v-if="!collapsed"
          class="whitespace-nowrap text-sm">
          {{ item.label }}
        </span>
      </RouterLink>
    </nav>

    <!-- Logout -->
    <nav class="mb-4 p-2 space-y-1">
      <a class="flex items-center gap-3 p-3 rounded-lg
               hover:bg-slate-800 transition" @click.prevent="logoutClick">
        <span
          class="w-6 h-6 flex items-center justify-center"
          v-html="collapsed ? logoutIcon.collapse : logoutIcon.expand"
        />
        <span
          v-if="!collapsed"
          class="whitespace-nowrap text-sm"
        >
          Logout
        </span>    
      </a>
    </nav>

    <!-- Toggle -->
    <button
      @click="toggle"
      class="h-14 border-t border-slate-700
             flex items-center justify-center
             hover:bg-slate-800 transition"
    >
      <span
        class="w-5 h-5"
        v-html="collapsed ? icons.expand : icons.collapse"
      />
    </button>
  </aside>
</template>
<script>
    export default {
    name: 'SidebarComponent',
    }
</script>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from "vue-router";

import { logout } from '@/services/common/authentication.service'
const router = useRouter();
const collapsed = ref(false)

const toggle = () => {
  collapsed.value = !collapsed.value
}

const items = [
  {
    link: '/admin',
    label: 'Dashboard',
    icon: `
      <svg viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="13" />
        <rect x="3" y="14" width="7" height="7" />
      </svg>`
  },
  {
    link: '/admin/links',
    label: 'Links',
    icon: `
      <svg viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
      </svg>`
  },
    {
    link: '/admin/files',
    label: 'Files',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
      </svg>`
  },
  {
    link: '/admin/categories',
    label: 'Categories',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" 
        stroke-width="1.5" 
        stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6Z" />
      </svg>
`
  },
  {
    link: '/admin/users',
    label: 'Users',
    icon: `
      <svg viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>`
  }
]

const icons = {
  collapse: `
    <svg viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>`,
  expand: `
    <svg viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>`
}

const logoutIcon = {
  collapse: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9" />
    </svg>`,
  expand: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9" />
    </svg>`
}

/* Auto collapse em mobile */
const handleResize = () => {
  collapsed.value = window.innerWidth < 768
}

onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

const logoutClick = async () => {
  try {
    await logout()
    router.push('/admin/signin');
  } catch (error) {
    console.error('Logout failed:', error);
  }
}


defineExpose({
  logoutClick
})

</script>
